$ = require 'jquery'
BoardAddToOrganizationView = require 'app/scripts/views/board-menu/board-add-to-organization-view'
AddListPopoverView = require 'app/scripts/views/board/add-list-popover-view'
{ Analytics } = require '@trello/atlassian-analytics'
Auth = require 'app/scripts/db/auth'
Backgrounds = require 'app/scripts/data/backgrounds'
BoardBackgroundPrompt = require 'app/scripts/views/board/board-background-prompt'
BoardBackgroundPromptTooltip = require 'app/scripts/views/board-menu/board-background-prompt-tooltip'
BoardCleanUpView = require 'app/scripts/views/board/board-clean-up-view'
BoardDescView = require 'app/scripts/views/board/board-desc-view'
BoardDisplayHelpers = require 'app/scripts/views/internal/board-display-helpers'
BoardHeaderOrgMenuView = require 'app/scripts/views/board/board-header-org-menu-view'
BoardSidebarView = require 'app/scripts/views/board-menu/board-sidebar-view'
BoardTagSelectView = require 'app/scripts/views/organization/board-tag-select-view'
Browser = require '@trello/browser'
Card = require 'app/scripts/models/card'
{ canAddCard } = require 'app/scripts/views/card/card-limits-error'
CardListView = require 'app/scripts/views/card/card-list-view'
CardView = require 'app/scripts/views/card/card-view'
ChangeBoardVisibilityView = require 'app/scripts/views/board-menu/change-board-visibility-view'
Confirm = require 'app/scripts/views/lib/confirm'
Controller = require 'app/scripts/controller'
CopyBoardHeaderButtonTeams = require 'app/scripts/data/copy-board-header-button-teams'
CopyBoardView = require 'app/scripts/views/board/copy-board-view'
Dialog = require 'app/scripts/views/lib/dialog'
DirectoryView = require 'app/scripts/views/directory/directory-view'
DragSort = require 'app/scripts/views/lib/drag-sort'
FavIcon = require 'app/scripts/lib/favicon'
GoogleMapsApi = require 'app/scripts/lib/google-maps-api'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
IdCache = require 'app/scripts/db/id-cache'
InspirationPopover = require 'app/scripts/views/onboarding/inspiration-popover'
InviteAcceptanceNotification = require 'app/scripts/views/board/invite-acceptance-notification'
InviteeOrientationView = require 'app/scripts/views/board/invitee-orientation-view'
{ getKey, Key, registerShortcutHandler, Scope, unregisterShortcutHandler, } = require '@trello/keybindings'
LabelState = require 'app/scripts/view-models/label-state'
Layout = require 'app/scripts/views/lib/layout'
LegacyPowerUps = require 'app/scripts/data/legacy-power-ups'
Limits = require 'app/scripts/lib/limits'
ListListView = require 'app/scripts/views/list/list-list-view'
ListView = require 'app/scripts/views/list/list-view'
locales = require('@trello/locale').supportedLocales
{ logoDomain } = require '@trello/config'
MemberBoardProfileView = require 'app/scripts/views/member/member-board-profile-view'
ModelLoader = require 'app/scripts/db/model-loader'
Payloads = require 'app/scripts/network/payloads'
PluginHeaderButtonsView = require 'app/scripts/views/plugin/plugin-header-buttons-view'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
PopOver = require 'app/scripts/views/lib/pop-over'
PostRender = require 'app/scripts/views/lib/post-render'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
removeAllRanges = require 'app/scripts/lib/util/removeAllRanges'
ReopenBoardPopoverView = require 'app/scripts/views/board/reopen-board-popover-view'
{ Storage } = require '@trello/storage'
Util = require 'app/scripts/lib/util'
Tooltip = require 'app/scripts/views/lib/tooltip'
View = require 'app/scripts/views/internal/view'
WindowSize = require 'app/scripts/lib/window-size'
_ = require 'underscore'
closedTemplate = require 'app/scripts/views/templates/board_closed'
l = require 'app/scripts/lib/localize'
log = require 'app/scripts/debug/log'
moment = require 'moment'
ninvoke = require 'app/scripts/lib/util/ninvoke'
templates = require 'app/scripts/views/internal/templates'
headerTemplate = require 'app/scripts/views/templates/board_header'
permsTemplate = require 'app/scripts/views/templates/board_header_permissions'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
{ Noun, Verb, track, trackUe } = require '@trello/analytics'
{ sendPluginUIEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
warningTemplate = require 'app/scripts/views/templates/board_header_warnings'
{ UnsplashTracker } = require '@trello/unsplash'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ isInspirationBoard } = require 'app/scripts/views/onboarding/helpers'
BoardHeaderAllMembersView = require 'app/scripts/views/board/board-header-all-members-view'
MemberOnBoardView = require 'app/scripts/views/member-menu-profile/member-on-board-view'
BoardMemberAddMultipleView = require 'app/scripts/views/board-menu/board-member-add-multiple-view'
{ maybeDisplayMemberLimitsError } = require 'app/scripts/views/board-menu/member-limits-error'
{ ErrorViews } = require 'app/common/data/error-views'
isDesktop = require('@trello/browser').isDesktop()
{ boardViewViewLoaders } = require './board-view-view-loaders'
{ BoardTemplateBadge } = require 'app/src/components/BoardTemplateBadge'
{ renderComponent } = require 'app/src/components/ComponentWrapper'
{ TeamlessCollaborationPrompt } = require 'app/src/components/TeamlessCollaborationPrompt'

BUTLER_POWER_UP_ID = require 'app/scripts/data/butler-id'
CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId
MAP_POWER_UP_ID = require('@trello/config').mapPowerUpId

MAX_FACEPILE_SIZE = 5

INVITE_ACCEPTANCE_NOTIFICATIONS_ENABLED_DATE = new Date('April 1, 2019')

module.exports = class BoardView extends View

  className: 'board-wrapper'

  events:
    'sortcommit': 'sortCommit'

    # For renaming boards in modern browsers
    'keydown .js-board-name-input': 'keyDownEvent'
    'input .js-board-name-input': 'onInputChanged'
    'change .js-board-name-input': 'onInputChanged'
      # Firefox uses "change" rather than "input"
    'blur .js-board-name-input': 'stopRenaming'
    'click .js-board-editing-target': 'startRenaming'

    'click .js-open-org-menu': 'openOrgMenu'

    'click .js-add-board-to-team:not(.no-edit)': 'addBoardToTeam'
    'click .js-change-vis': 'changeVis'
    'click .js-open-desc': 'openDesc'
    'click .js-close-calendar': 'toggleCalendar'
    'click .js-calendar': 'toggleCalendar'
    'click .js-close-map': 'toggleMap'
    'click .js-map-btn': 'toggleMap'

    'click .js-filter-cards-indicator': 'openFilter'
    'click .js-filter-card-clear': 'clearFilters'
    'click .js-board-header-subscribed': 'openUnsubscribe'

    'click .js-star-board': 'toggleStarred'

    'click .js-show-sidebar': (e) ->
      trackUe('board sidebar', 'opens', 'sidebar', '', '', '', { boardId: @model.id, teamId: @model.getOrganization()?.id } )
      Analytics.sendUIEvent
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'boardMenuToggleLink',
        attributes:
          boardId: @model.id
          organizationId: @model.get('idOrganization')
        source: 'boardScreen',
      @setSidebarShow()

    'click .js-dismiss-warning': (e) ->
      Storage.set(@$(e.currentTarget).attr('data-dismiss'), Date.now())
      @renderBoardWarnings()

    'dblclick #board': 'dblClickAddListMenu'
    'click #board': 'blurInputsOnBoardClick'

    'click .js-reopen': 'reopen'
    'click .js-delete': 'delete'

    'click .js-clean-up': 'showCleanUp'

    'prevent-scroll-selection': 'preventScrollSelection'

    'click .js-close-directory': 'clickCloseDirectory'

    'click .js-copy-board': 'copyBoard'
    'click .js-open-show-all-board-members': 'openAllMembers'
    'click .js-open-manage-board-members': 'openAddMembers'
    'click .js-join-board': 'joinBoard'

  constructor: ({ @headerBranding }) ->
    super

  initialize: ->
    super
    @templateFlagEnabled = featureFlagClient.get('publicproduct.templates_v1', false)
    featureFlagClient.on 'publicproduct.templates_v1', (newVal) =>
      @templateFlagEnabled = newVal
      @renderBoardHeaderDebounced()

    @sidebarView = @subview BoardSidebarView, @model, { boardView: @ }
    @inviteAcceptanceNotificationDiv = null
    @inviteAcceptanceNotificationComponent = null
    @teamlessCollaborationPromptDiv = null
    @teamlessCollaborationPromptComponent = null

    @makeDebouncedMethods 'refreshOrganization',
      'reloadCustomFields'
      'render'
      'renderBoardBackground'
      'renderBoardHeader'
      'renderBoardHeaderCalendar'
      'renderBoardHeaderDescription'
      'renderBoardHeaderSubscribed'
      'renderBoardHeaderMap'
      'renderBoardWarnings'
      'renderLists'
      'renderPermissionLevel'
      'updateControllerTitle'
      'renderBoardHeaderFacepile'
      'renderPluginButtons'

    @listenTo @model,
      'change:closed deleting': @renderDebounced
      'change:desc': @renderBoardHeaderDescriptionDebounced
      'change:idOrganization': =>
        @reloadDirectoryPlugins = true
        @refreshOrganizationDebounced()
        @headerBranding()
      'change:memberships': @renderPermissionLevelDebounced
      'change:limits': @renderBoardWarningsDebounced
      'change:name': =>
        @renderBoardHeaderDebounced()
        @updateControllerTitleDebounced()
      'change:powerUps': ->
        @renderBoardHeaderMapDebounced()
        if !@model.isMapPowerUpEnabled()
          @closeMap()
        @renderBoardHeaderCalendarDebounced()
        if !@model.isPowerUpEnabled('calendar')
          @closeCalendar()
      'change:prefs.cardCovers': @renderListsDebounced
      'change:prefs.permissionLevel': =>
        @renderListsDebounced()
        @renderPermissionLevelDebounced()
      'change:prefs.background change:prefs.backgroundTile change:prefs.backgroundBrightness': =>
        @renderBoardBackgroundDebounced(true)
        @renderPluginButtonsDebounced()
      'change:prefs.isTemplate': @renderBoardHeaderDebounced
      'change:prefs.selfJoin': @renderBoardHeaderDebounced
      'change:subscribed': @renderBoardHeaderSubscribedDebounced
      'permChange': @permChange
      'ownedChange': @renderBoardHeaderDebounced
      'destroy': =>
        Controller.displayErrorPage
          errorType: ErrorViews.BOARD_NOT_FOUND

    @listenTo @model.memberList,
      'change:status': @renderBoardHeaderDebounced
      'add': @onMemberAdd
      'remove reset': @renderBoardHeaderFacepileDebounced

    @listenTo @model.boardPluginList, 'add reset', =>
      @reloadCustomFieldsDebounced()

    @subscribe pluginsChangedSignal(@model), =>
      @renderBoardHeaderMapDebounced()
      if !@model.isMapPowerUpEnabled()
        @closeMap()
      @renderBoardHeaderCalendarDebounced()
      if !@model.isPowerUpEnabled('calendar')
        @closeCalendar()

    @listenTo @model.viewState,
      'change:showSidebar': @renderSidebarState
      'change:sidebarDisplayType': @renderSidebarDisplayType
      'change:showBoardBackgroundPromptPopover': @renderBoardBackgroundPromptPopover

    @listenTo Auth.me().boardStarList, 'add remove reset', =>
      @renderBoardHeaderStarred()

    @memberTypeMe = @model.getMemberType(Auth.me())

    @refreshOrganization()

    @listScrollLeft = null
    @savingScroll = false
    @calcState = {}

    @listenTo @model.filter, 'change', =>
      @renderFilteringStatus()
      @renderBoardHeader()

    registerShortcutHandler(@onShortcut, { scope: Scope.Board })

    @listListView = @collectionSubview ListListView, @model.listList,
      id: 'board'
      model: @model
      className: 'u-fancy-scrollbar js-no-higher-edits'
      resetCallback: => @postListListRender()


    # Why are we listening to mousemove? Isn't mouseenter sufficient?
    #
    # 1. Hover your mouse over a card
    # 2. Hit an arrow key, moving the selected card, but not in a way that
    #    scrolls the page -- so the mouse is still hovering over the original
    #    card view.
    # 3. Move your mouse.
    #
    # If we were only listening to mouseenter, we'd never select the card,
    # because the mouse didn't re-enter it.
    @listenTo @listListView,
      'mouseMoveListView': (listView) ->
        list = listView.model
        @model.viewState.selectList listView.model
      'mouseLeaveListView': (listView) ->
        list = listView.model
        @model.viewState.selectList null
      'mouseMoveCardView': (listView, cardView) ->
        if @ignoreMouseCardSelects || PopOver.isVisible || DragSort.sorting
          return
        @model.viewState.selectCard cardView.model
      'mouseLeaveCardView': (listView, cardView) ->
        if @ignoreMouseCardSelects || PopOver.isVisible || DragSort.sorting
          return
        @model.viewState.selectCard null
      'moveCard': @moveCardRequested
      'copyCard': @copyCardRequested

    @_applySettings()
    @markRelatedNotificationsRead()

    @reloadDirectoryPlugins = false


    if featureFlagClient.get('dataeng.gasv3-event-tracking', false) # feature flag on
      Analytics.sendScreenEvent
        name: 'boardScreen',
        attributes:
          isTemplate: @isTemplate()
          visibility: @model.getPermLevel()
        containers:
          board:
            id: @model.id
          organization:
            id: @model.getOrganization()?.id || ''

    return

  onMemberAdd: ->
    @renderBoardHeaderFacepileDebounced()

  unmountBoardBackgroundPrompt: ->
    if @boardBackgroundPromptDiv
      ReactDOM.unmountComponentAtNode(@boardBackgroundPromptDiv)
    @boardBackgroundPromptDiv = null
    @boardBackgroundPromptComponent = null

  unmountBoardBackgroundPromptPopover: ->
    if @boardBackgroundPromptPopoverDiv
      ReactDOM.unmountComponentAtNode(@boardBackgroundPromptPopoverDiv)
    @boardBackgroundPromptPopoverDiv = null
    @boardBackgroundPromptPopoverComponent = null

  renderBoardBackgroundPrompt: ->
    if @boardBackgroundPromptDiv?
      @unmountBoardBackgroundPrompt()
    @boardBackgroundPromptDiv ?= document.createElement('div')
    @model.viewState.set('initialBackgroundColor', @model.attributes.prefs.background)

    @setTimeout(=>
      me = Auth.me()

      if !featureFlagClient.get('board.background.prompt', false) \
      || @model.get('prefs').backgroundImage? \
      || !me.isLoggedIn() \
      || !me.isNewMember() \
      || me.isDismissed('board-background-prompt') \
      || !@model.isFirstOwnedBoard() \
      || !@model.owned() \
      || @model.memberList.length > 1 \
      || isInspirationBoard(@model.get('id'))
        return

      # I put this seperate to be clear that this needs to be called after all of the
      # other constraints pass, since calling getExperiment has the side effect of
      # actually bucketing users in snowplow. We'd only want to bucket them if all the
      # above constraints are *not* met
      if getExperiment('boardBackgroundPrompt').get('variation') == 'control'
        return

      trackUe('Board Background Prompt', 'View Prompt')

      @boardBackgroundPromptComponent = React.createElement BoardBackgroundPrompt, {
        model: @model
        onBrowse: =>
          @model.viewState.set('boardBackgroundPromptOpenedSidebar', true)
          @sidebarView.pushView 'backgroundPhotos', component: 'photos'
          @unmountBoardBackgroundPrompt()
        onDismiss: =>
          @model.viewState.set('showBoardBackgroundPromptPopover', true)
          @unmountBoardBackgroundPrompt()
      }
      @$('.board-canvas').append(@boardBackgroundPromptDiv)
      ReactDOM.render(@boardBackgroundPromptComponent, @boardBackgroundPromptDiv)
    , 2 * 1000)

  renderBoardBackgroundPromptPopover: ->
    if !@model.viewState.get('showBoardBackgroundPromptPopover') \
    || @model.viewState.get('showSidebar')
      @unmountBoardBackgroundPromptPopover()
      return

    @boardBackgroundPromptPopoverComponent = React.createElement(
      BoardBackgroundPromptTooltip,
      {
        onDismiss: =>
          @model.viewState.set('showBoardBackgroundPromptPopover', false)
          @unmountBoardBackgroundPromptPopover()
      }
    )
    @boardBackgroundPromptPopoverDiv = document.createElement('div')
    $(@boardBackgroundPromptPopoverDiv).insertAfter('.js-show-sidebar')
    ReactDOM.render(@boardBackgroundPromptPopoverComponent, @boardBackgroundPromptPopoverDiv)

  isTemplate: ->
    @templateFlagEnabled && @model.isTemplate()

  renderBoardTemplateReactSection: ->
    $('.js-board-template-badge').append(@boardTemplateBadgeDiv)
    ReactDOM.render(@boardTemplateBadgeComponent, @boardTemplateBadgeDiv)

  renderBoardTemplateBadge: ->
    if !@isTemplate()
      if @boardTemplateBadgeDiv
        ReactDOM.unmountComponentAtNode(@boardTemplateBadgeDiv)
        @boardTemplateBadgeDiv = null
        @boardTemplateBadgeComponent = null
      return

    previouslyRendered = @boardTemplateBadgeDiv? && @boardTemplateBadgeComponent?
    if !previouslyRendered
      # Defer here since the target div that is being rendered by Backbone may
      # not be available yet.
      _.defer =>
        @boardTemplateBadgeComponent = React.createElement(BoardTemplateBadge)
        @boardTemplateBadgeDiv = document.createElement('div')
        @renderBoardTemplateReactSection()
    else
      @renderBoardTemplateReactSection()

  _applySettings: ->
    if !@options.settings?
      return

    { menu, filter } = @options.settings

    switch menu
      when 'closed'
        @model.viewState.setShowSidebar(false)
      when 'filter', 'activity'
        @setSidebarShow()
        @sidebarView.pushView(menu)

    if filter
      @model.filter.fromQueryString(filter)

  permChange: (newPerm) ->
    if newPerm == 'none'
      Controller.memberHomeView()
    else
      @render()
      # If we can't edit the board, hide the card composer (if it's open)
      if !@model.editable()
        @model.composer.save('vis', false)
    return

  onShortcut: (event) =>
    editable = @model.editable()
    isLoggedIn = Auth.isLoggedIn()

    switch getKey(event)
      when Key.q
        if isLoggedIn
          @model.filter.toggleQuietMode()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'Q - My cards'

      when Key.x
        @model.filter.clear()
        event.preventDefault()
        track 'Keyboard Shortcuts', 'X - Clear All Filters'

      when Key.w
        @toggleSidebar()
        event.preventDefault()
        track 'Keyboard Shortcuts', 'W - Toggle Board Sidebar'

      when Key.SemiColon
        wasShowingLabelText = LabelState.getShowText()
        LabelState.toggleText()
        event.preventDefault()
        track(
          "Toggle Labels Text on Card Front",
          if wasShowingLabelText then "Hide" else "Show",
          @model.id,
          "shortcut"
        )
        track 'Keyboard Shortcuts', '; - Toggle Label Text'

      when Key.ArrowDown, Key.j
        @moveCard('down')
        event.preventDefault()
        track 'Keyboard Shortcuts', 'Keyboard Nav', 'Down'

      when Key.ArrowUp, Key.k
        @moveCard('up')
        event.preventDefault()
        track 'Keyboard Shortcuts', 'Keyboard Nav', 'Up'

      when Key.ArrowRight
        @moveCard('right')
        event.preventDefault()
        track 'Keyboard Shortcuts', 'Keyboard Nav', 'Right'

      when Key.ArrowLeft
        @moveCard('left')
        event.preventDefault()
        track 'Keyboard Shortcuts', 'Keyboard Nav', 'Left'

      when Key.n
        if editable
          list = @model.viewState.getList()
          card = @model.viewState.getCard()

          if list?
            index =
              if card?
                list.openCards().indexOf(card) + 1
              else
                list.openCards().length

            @model.composer.save({
              list: list
              index: index
              vis: true
            })

            event.preventDefault()
            track 'Keyboard Shortcuts', 'N - Insert Card'

      when Key.Escape
        if editable

          if DragSort.sorting
            DragSort.abort()
          else if !(Layout.isEditing() || PopOver.isVisible || Dialog.isVisible)
            if @model.composer.get('vis')
              @model.composer.save("vis", false)
            else if @model.viewState.get('listComposerOpen')
              @model.viewState.set('listComposerOpen', false)
            else
              @sidebarView.popView()

          if Controller.showingCalendar(@)
            $('.calendar-day.active').removeClass('active')

          event.preventDefault()

  openListComposer: ->
    @model.viewState.openListComposer()

  openCardComposerInFirstList: ->
    firstList = @model.listList.first()
    @model.composer.save({
      list: firstList
      index: firstList.openCards().length
      vis: true
    })
    trackUe('card composer', 'open', '', '', '', 'via navigating to board', { 'boardid': @model.get('id') })
    return

  scrollToList: (list) ->
    Util.scrollElementIntoView @$('#board')[0], @viewForList(list).el,
      horizontal: true
      animated: true
    return

  viewForList: (list) ->
    return @listListView.viewForModel(list)

  scrollToCard: (card) ->
    list = card.getList()
    @scrollToList(list)
    @viewForList(list).scrollToCard(card)

  preventScrollSelection: ->
    # So here's the deal.
    #
    # When you're selecting cards with the keyboard, we'll scroll the
    # board and the lists on it to ensure the currently selected card
    # is always visible.
    #
    # As a result of this scrolling, it's possible that the mouseenter event
    # will fire on a CardView -- which, if you look above at the handling of
    # mouseEnterCardView, will cause us to mark the newly hovered card as
    # selected, even though you didn't actually move the mouse at all.
    #
    # So we remember that we've just selected something with the keyboard,
    # and we should ignore mouse events until the next time the user moves
    # the mouse.
    #
    # But.
    #
    # Chrome will fire mousemove events even when the mouse *hasn't* moved,
    # as a result of the scroll.
    #
    # https://code.google.com/p/chromium/issues/detail?id=241476
    #
    # So we can't just wait for the next mousemove event -- we have to wait
    # for the next mousemove event that has occurred as the result of the
    # user moving the mouse.
    #
    # Detecting that is a bit of a hack, but appears to work well enough for
    # now.
    #
    # IE 10 will apparently just fire mousemove events constantly, even
    # when a scroll doesn't occur. I don't know how to fix that. I can't find
    # a good workaround for IE 10. So that's just not gonna work.

    if @ignoreMouseCardSelects
      return

    isResultOfActualPhysicalMouseMovement = (e) ->
      { movementX: x, movementY: y } = e.originalEvent
      x != 0 || y != 0

    @ignoreMouseCardSelects = true

    bindOnce = =>
      $(document).one 'mousemove', (e) =>
        if isResultOfActualPhysicalMouseMovement(e)
          @ignoreMouseCardSelects = false
        else
          bindOnce()
        return

    bindOnce()
    return

  markRelatedNotificationsRead:  ->
    isRelatedAndUnread = (notification) =>
      notification.get('unread') &&
      !notification.get('data')?.card? &&
      notification.get('data').board?.id == @model.get('id')
    for notification in @modelCache.all('Notification') when isRelatedAndUnread(notification)
      notification.markRead()
    return

  moveCard: (direction) ->
    @preventScrollSelection()

    selectedCard = @model.viewState.getCard()

    if !selectedCard?
      # Select the first card in the first list that has a card
      listWithCards =
        @model.listList.find (list) -> !list.openCards().isEmpty()
      listWithCards?.selectFirstCardInList()
      return

    selectedList = selectedCard.getList()

    openCards = selectedList.openCards()
    cardIndex = openCards.indexOf(selectedCard)

    findNextGoodIndex = (currentIndex, indexDelta, upperBound, fxIndexIsGood) =>
      newIndex = currentIndex + indexDelta
      if @model.filter.isFiltering
        while 0 <= newIndex < upperBound && !fxIndexIsGood(newIndex)
          newIndex += indexDelta
      # We just return something out of bounds if there's no index that works
      return newIndex

    if direction in ['up', 'down']
      indexDelta = if direction == 'up' then -1 else 1
      newCardIndex = findNextGoodIndex cardIndex, indexDelta, openCards.length, (newCardIndex) =>
        @model.filter.satisfiesFilter(openCards.at(newCardIndex))

      if 0 <= newCardIndex < openCards.length
        card = openCards.at(newCardIndex)
        @scrollToCard card
        @model.viewState.selectCard card

    else if direction in ['left', 'right']
      openLists = @model.listList
      listIndex = openLists.indexOf(selectedList)

      listIndexDelta = if direction == 'left' then -1 else 1
      newListIndex = findNextGoodIndex listIndex, listIndexDelta, openLists.length, (newListIndex) =>
        openLists.at(newListIndex).openCards().any (card) =>
          @model.filter.satisfiesFilter(card)
      if 0 <= newListIndex < openLists.length
        newList = openLists.at(newListIndex)
        newListOpenCards = newList.openCards()
        newCardIndexStart = Math.min(cardIndex, newListOpenCards.length - 1)
        for delta in [1, -1]
          newCardIndex = findNextGoodIndex newCardIndexStart - delta, delta, newListOpenCards.length, (newCardIndex) =>
            @model.filter.satisfiesFilter(newListOpenCards.at(newCardIndex))
          if 0 <= newCardIndex < newListOpenCards.length
            card = newListOpenCards.at(newCardIndex)
            @model.viewState.selectCard card
            @scrollToCard card
            break

  unmountInspirationPopover: =>
    if @inspirationPopoverDiv?
      ReactDOM.unmountComponentAtNode(@inspirationPopoverDiv)
      @inspirationPopoverDiv = null

  renderInspirationPopover: ->
    if !featureFlagClient.get('activation.onboarding_v2') || \
     !isInspirationBoard(@model.get('id'))
      return

    timeout = 0
    # Dont use a board-canvas element to mount, because then the popover will be unmounted
    # when a new board is selected from the popover
    # Corresponding code to remove popover is in controller/index.coffee
    if !@inspirationPopoverDiv
      timeout = 2000
      $('#surface').append('<div id="js-inspiration-popover-mount"></div>')
      @inspirationPopoverDiv = $('#js-inspiration-popover-mount')[0]

    setTimeout(=>
      ReactDOM.render(
        React.createElement(InspirationPopover, {
          onClose: @unmountInspirationPopover
          boardId: @model.get('id')
          @modelCache
        })
        , @inspirationPopoverDiv
      )
    , timeout)

    @

  renderClosed: ->
    @unmountTeamlessCollaborationPrompt()
    @unmountInspirationPopover()
    org = @model.getOrganization()
    isAtOrOverLimit = org?.isAtOrOverFreeBoardLimit()
    @$el.html closedTemplate({
      name: @model.get('name')
      canReopen: @model.owned()
      canDelete: @model.canDelete()
      deleting: @model.isDeleting()
      isAtOrOverLimit: isAtOrOverLimit
      isDesktop: isDesktop
      orgName: org?.get('displayName')
      billingUrl: org?.getBillingUrl()
    })
    @defaultBoardBackground()
    return

  _shouldCloseBoardMenu: ->
    isNewBoard = (new Date() - Util.idToDate(@model.id)) < 180000

    # if a previous render of this board marked it as needing its menu closed,
    # keep it closed until the user opens it themselves
    @shouldCloseBoardMenu ||
    # close the menu of the first board they ever load
    !Auth.me().isDismissed('close-menu-of-first-board') ||
    # close menu of first board ever created, which may not be the same as the
    # first board they ever load, because of invitations
    (isNewBoard && @model.isFirstOwnedBoard()) ||
    # Its an inspiration board made from onboarding
    isInspirationBoard(@model.get('id'))

  _isFirstBoardEverLoaded: ->
    !Auth.me().isDismissed('close-menu-of-first-board') && !@model.isWelcomeBoard()

  _isGhostUsingInviteLink: ->
    Util.hasValidInviteTokenFor(@model)

  renderOpen: ->
    @showSidebarOnOpen()

    data = {}
    data.url = Controller.getBoardUrl(@model)
    for preference in @model.prefNames.concat(@model.myPrefNames)
      data["#{preference}_#{@model.getPref(preference)}"] = true
    data.canJoin = @model.canJoin()
    data.canInviteMembers = @model.canInviteMembers()
    data.confirmed = Auth.me().get('confirmed')

    @listListView.$el.detach()
    @$el.html templates.fillFromModel('board', @model)

    @renderBoardHeader()
    @renderBoardWarnings()
    @renderBoardBackground()

    # this prevents the sidebar from animating in when first rendering.
    if @model.viewState.get('showSidebar')
      @$el.addClass('is-show-menu')

    @appendSubview @sidebarView, @$('.js-fill-board-menu')

    @renderSidebarState()
    @renderLists()
    @renderInspirationPopover()
    @renderInviteeOrientation()
    @renderBoardBackgroundPrompt()

    Controller.setLocation(title: data.name)

    @defer =>
      @$('#board').unbind('mousedown.dragscrollable').dragscrollable
        fxIgnore: (event) ->
          boardEl = $(event.target).closest('#board')
          isScrollbar = event.offsetY > (boardEl.height() - 11)
          isList = $(event.target).closest('.js-list-content').length > 0
          isListComposer = $(event.target).closest('.js-add-list').length > 0
          isScrollbar || isList || isListComposer

      DragSort.refreshListSortable()
    return

  render: ->
    if @model.get('closed') && !isInspirationBoard(@model.get('id'))
      @renderClosed()
    else
      @renderOpen()

    return @

  renderFilteringStatus: ->
    isFiltering = @model.filter.isFiltering()
    @$('.js-filter-cards-indicator').toggleClass('hide', !isFiltering)
    @$('.js-num-cards').toggleClass('hide', !isFiltering)
    @$('#board').toggleClass('filtering', isFiltering)

    queryString = @model.filter.toQueryString()

    history.replaceState(null, null, location.pathname + queryString)

  removeSidebarDisplayTypes: ->
    @$el.removeClass('sidebar-display-wide')
    return

  renderSidebarDisplayType: ->
    displayClass = @model.viewState.getSidebarDisplayType()
    @$el.addClass(displayClass)
    return

  showSidebarOnOpen: ->
    # Orient visitors to public boards if About This Board is enabled
    fromPrefOrNotLoggedIn = @model.viewState.getShowSidebarFromPref() || Auth.me().get('notLoggedIn')
    hasDesc = !!@model.get('desc')
    isMember = @model.isMember(Auth.me())
    if @model.isPublic() && !isMember && hasDesc && fromPrefOrNotLoggedIn && !Browser.isTouch()
      @model.viewState.set("showSidebar", true)
    else if @_shouldCloseBoardMenu() || Browser.isTouch()
      @model.viewState.set("showSidebar", false)
      if @_isFirstBoardEverLoaded() && !@_isGhostUsingInviteLink()
        @shouldCloseBoardMenu = true
        if (Auth.isLoggedIn())
          Auth.me().dismiss('close-menu-of-first-board')
    else
      @model.viewState.setShowSidebarFromPref()

  renderSidebarState: ->
    @renderSidebarDisplayType()

    if @model.viewState.get('showSidebar')
      @showSidebar()
      @model.viewState.set('showBoardBackgroundPromptPopover', false)
    else
      @hideSidebar()
      if @model.viewState.get('boardBackgroundPromptOpenedSidebar')
        @model.viewState.set('boardBackgroundPromptOpenedSidebar', false)
        @model.viewState.set('showBoardBackgroundPromptPopover', true)

    return

  toggleSidebar: ->
    @model.viewState.setShowSidebar(!@model.viewState.get('showSidebar'))

  setSidebarShow: ->
    @model.viewState.setShowSidebar(true)
    @shouldCloseboardMenu = false
    return

  showSidebar: ->
    @renderSidebarDisplayType()

    # Hacky... the entire transition will be hidden if
    # there isn't a slight delay between unhiding and
    # enabling the transition class.
    clearTimeout @_sidebarHideTimeout
    @$('.js-fill-board-menu').removeClass('hide')
    @defer =>
      @$el.addClass('is-show-menu')

    Analytics.sendScreenEvent
      name: 'boardSidebarDrawer'
      attributes:
        boardId: @model.id
        organizationId: @model.get('idOrganization')

    return

  hideSidebar: ->
    @$el.removeClass('is-show-menu')
    clearTimeout @_sidebarHideTimeout
    # Even though the is-show-menu class moves the menu out of view, we want
    # to also *actually* hide it, so the browser doesn't does something weird
    # when the user does something like Ctrl+F for text that appears in the
    # sidebar.
    #
    # We're delaying the hide because we're giving the CSS transition time to
    # complete.  We could try to trigger off of the transitionEnd event but
    # that can be problematic (if another transition starts before the first
    # one finishes or doesn't happen at all because there isn't actually a
    # change in the property being transitioned)
    #
    # The timeout value we're using here isn't meant to match the length of the
    # transition, but hopefully it's longer than whatever the transition is,
    # but not so short that someone could reasonably hide the menu and then
    # Ctrl+F for something that was on it
    @_sidebarHideTimeout = @setTimeout =>
      @$('.js-fill-board-menu').addClass('hide')
      if @model.viewState.get('boardBackgroundPromptOpenedSidebar')
        @renderBoardBackgroundPromptPopover()
    , 250

    return

  renderOrgChanges: ->
    if @model.get('closed')
      @renderClosed()
    else
      @renderBoardHeader()

  refreshOrganization: ->
    oldOrganization = @modelCache.get('Organization', @model.previous('idOrganization'))
    organization = @model.getOrganization()

    if oldOrganization?
      @stopListening oldOrganization

    if organization?
      for prop in ['name', 'logoHash', 'displayName', 'limits']
        @listenTo organization, "change:#{prop}",
          @frameDebounce @renderOrgChanges

    @renderOrgChanges()

  reloadCustomFields: ->
    if @model.isPluginEnabled(CUSTOM_FIELDS_ID)
      # we need to give the server a second to prevent any race conditions
      # mainly if we were the ones to enable custom fields
      setTimeout =>
        ModelLoader.loadCustomFields(@model.id)
      , 1000

  renderBoardHeader: ->
    isPremOrgAdmin = @model.isPremOrgAdmin(Auth.me())

    data =
      name: @model.get('name')
      canRename: isPremOrgAdmin || @model.owned()
      isLoggedIn: Auth.isLoggedIn()
      isAdmin: @model.ownedByMember(Auth.me())
      isMember: @model.isMember(Auth.me())
      isPrivateTeam: @model.hasOrganization() && !@model.getOrganization()
      isPrivateTeamForEnterpriseVisibleBoard: @model.hasOrganization() && @model.getPref('permissionLevel') == 'enterprise'
      isUntitled: @model.get('name') == l(['untitled board'])
      canJoin: @model.canJoin()
      canInviteMembers: @model.canInviteMembers()
      selfJoin: @model.allowsSelfJoin()
      canAssign: @model.editable()
      boardCardCount: @model.openCards()?.filter((card) => @model.filter.satisfiesFilter(card)).length
      templateModeEnabled: @isTemplate()

    data.starTooltipKey = if @isTemplate()
        'click-to-star-or-unstar-this-template-starred-templates-show-up-at-the-top-of-your-boards-list'
      else
        'click-to-star-or-unstar-this-board-starred-boards-show-up-at-the-top-of-your-boards-list'

    organization = @model.getOrganization()
    if organization?
      data.orgDisplayName = organization.get('displayName')
      data.orgName = organization.get('name')
      data.showCopyButton = _.contains(CopyBoardHeaderButtonTeams, organization.id)
      _hash = organization.get('logoHash')
      enterprise_hash = organization.getEnterprise()?.get('logoHash')
      if enterprise_hash && featureFlagClient.get('enterprise.corporate-visibility')
        data.orgLogoUrl = "#{logoDomain}/#{enterprise_hash}/30.png"
        data.orgLogoUrl2x = "#{logoDomain}/#{enterprise_hash}/170.png"
      else if _hash
        data.orgLogoUrl = "#{logoDomain}/#{_hash}/30.png"
        data.orgLogoUrl2x = "#{logoDomain}/#{_hash}/170.png"
      data.hasBusinessClass = organization.isPremium()
      data.isBusinessClass = organization.isBusinessClass()
      data.isEnterprise = organization?.get('idEnterprise')

    @$('.js-board-header').html headerTemplate(data)

    @renderPermissionLevel()
    @renderBoardHeaderDescription()
    @renderBoardHeaderCalendar()
    @renderBoardHeaderSubscribed()
    @renderBoardHeaderMap()
    @renderFilteringStatus()
    @renderBoardHeaderStarred()
    @renderPluginButtons()
    @renderBoardHeaderFacepile()
    @renderBoardBackgroundPromptPopover()
    @renderBoardTemplateBadge()

    @

  renderBoardWarnings: ->
    $warnings = @$('.js-board-warnings')

    perBoardLimits = Limits.sort(
      Limits.filterByKeys(@model.get('limits'), [
        'cards.openPerBoard',
        'cards.totalPerBoard',
        'checklists.perBoard',
        'labels.perBoard',
        'lists.openPerBoard',
        'lists.totalPerBoard',
        'attachments.perBoard',
      ]).filter (l) -> l.status != 'ok'
    )
    templateMap = {
      'cards.openPerBoard': 'open-cards-per-board-limit',
      'cards.totalPerBoard': 'total-cards-per-board-limit',
      'checklists.perBoard': 'checklists-per-board-limit',
      'labels.perBoard': 'labels-per-board-limit',
      'lists.openPerBoard': 'open-lists-per-board-limit',
      'lists.totalPerBoard': 'total-lists-per-board-limit',
      'attachments.perBoard': 'attachments-per-board-limit',
    }
    isEditable = @model.editable()
    minDismiss = Util.dateBefore(months: 6)
    warnings = perBoardLimits.map (limit) ->
      name = limit.key
      status = if limit.status == "warn"
        "warn"
      else
        "disabled"
      key = "#{templateMap[limit.key]}-#{status}"
      test = => isEditable
      [name, { key, test, minDismiss }]

    dismissWarningName = (name) =>
      "BoardWarning-#{name}-#{ @model.id }"

    warning = _.chain(warnings)
      .filter ([name, { test, minDismiss }]) ->
        if test()
          dismissed = Storage.get(dismissWarningName(name))
          !dismissed || dismissed < minDismiss
      .map ([name, { key }]) ->
        { name, key, dismiss: dismissWarningName(name) }
      .first()
      .value()

    _.chain(warnings)
    .filter ([name, { test }]) ->
      !test() && Storage.get(dismissWarningName(name))?
    .each ([name]) ->
      Storage.unset(dismissWarningName(name))
    .value()

    if warning
      $warnings.removeClass('hide').html warningTemplate({
        canDismiss: Storage.isEnabled(),
        warning
      })
    else
      $warnings.addClass('hide')

    @

  renderPluginButtons: ->
    if @pluginHeaderButtonsView?
      @pluginHeaderButtonsView.requestButtonsDebounced()
    else
      @pluginHeaderButtonsView = @subview PluginHeaderButtonsView, @model
    @appendSubview @pluginHeaderButtonsView, @$('.js-plugin-header-btns')

    @

  renderBoardHeaderStarred: ->
    @$('.js-star-board').toggleClass('board-header-btn-enabled', @model.isStarred())
    @

  toggleStarred: ->
    boardStarList = Auth.me().boardStarList

    if boardStarList.getBoardStar(@model.id)?
      boardStarList.unstarBoard(@model.id)
      track("Board Header", "Unstar Board")
    else
      boardStarList.starBoard(@model.id)
      track("Board Header", "Star Board")

    @

  renderBoardHeaderCalendar: ->
    isEnabled = @model.isPowerUpEnabled('calendar')
    @$('.js-calendar').toggleClass('hide', !isEnabled)
    @

  getAllBackgroundClasses: ->
    [
      'body-custom-board-background'
      'body-custom-board-background-tiled'
      'body-light-board-background'
      'body-dark-board-background'
      'body-ambiguous-board-background'
      'body-default-header'
    ].join(" ")

  defaultBoardBackground: ->
    @clearBoardBackground()
    $('#trello-root').addClass('body-default-header')
    return

  clearBoardBackground: ->
    prefs = @model.get('prefs')
    allBackgroundClasses = @getAllBackgroundClasses()

    $('#trello-root')
    .removeClass(allBackgroundClasses)
    .css
      'background-image': ''
      'background-color': ''

    return

  renderBoardBackground: (waitForImage = false) ->
    @clearBoardBackground()

    prefs = @model.get('prefs')
    $body = $('#trello-root')

    if prefs.backgroundColor?
      hexcolor = @model.getClientBackgroundColor(prefs.background)

      $body.css
        'background-color': hexcolor

      FavIcon.setBackground({ color: hexcolor })

    else
      if Backgrounds.hasOwnProperty(prefs.background)
        # Special handling for our default backgrounds, to avoid using the
        # really huge versions
        url = Util.smallestPreviewBiggerThan(
          prefs.backgroundImageScaled,
          640,
          480
        )?.url ? prefs.backgroundImage
      else
        url = prefs.backgroundImage

      if prefs.backgroundTile
        smallUrl = url
      else
        smallUrl =
          Util.smallestPreviewBiggerThan(
            prefs.backgroundImageScaled
            64
            64
          )?.url ? prefs.backgroundImage


      changeBackgroundImage = =>
        $body.addClass('body-custom-board-background')

        if prefs.backgroundTile
          $body.addClass('body-custom-board-background-tiled')

        brightness = prefs.backgroundBrightness

        if prefs.backgroundTopColor
          topBrightness = Util.calculateBrightness(prefs.backgroundTopColor)

          if brightness != topBrightness
            $body.addClass('body-ambiguous-board-background')

        switch brightness
          when 'light'
            $body.addClass('body-light-board-background')
          when 'dark'
            $body.addClass('body-dark-board-background')


        $body
        .css
          'background-image': "url(\"#{url}\")"

        UnsplashTracker.trackOncePerInterval url

        FavIcon.setBackground({ url: smallUrl, tiled: prefs.backgroundTile })

      if waitForImage
        Util.waitForImageLoad url
          .then changeBackgroundImage
      else
        changeBackgroundImage()

  renderBoardHeaderSubscribed: ->
    isSubscribed = @model.get('subscribed')
    @$('.js-board-header-subscribed').toggleClass('hide', !isSubscribed)
    @

  renderBoardHeaderDescription: ->
    $desc = @$('.js-fill-desc')
    desc = @model.get('desc')
    if !desc
      $desc.addClass('hide')
      return @

    if desc
      title = desc
    else if @model.editable()
      title = l('click to add a description')

    $desc.attr('title', title)
    $desc.removeClass('hide')

    @

  saveBoardName: (e) ->
    boardInput = @$('.js-board-name-input')
    val = boardInput && boardInput.val().trim()
    if val == ''
      boardInput.focus().select()
      return
    track("Board", "Successfully Rename Board")
    @model.update("name", val)
    return

  keyDownEvent: (e) ->
    if getKey(e) == Key.Enter
      Util.stop(e) # prevents new lines.
      @stopRenaming()
      return

    if getKey(e) == Key.Escape
      @stopRenaming()
      return

    return

  onInputChanged: (e) ->
    input = @$el.find('.js-board-name-input')[0]

    # First, we set the input width to 0, then we can measure how wide it needs to be for the content.
    input.style.width = '0'
    inputWidthForNewValue = input.offsetWidth

    # An element's scrollLeft represents the amount the element has been scrolled.
    # Setting an element's scrollLeft actually scrolls the element rather than setting the value,
    # and it can only scroll as far as the content goes— so here we're scrolling all the way to
    # the end of the content by using an absurd number.
    input.scrollLeft = 1e+10
    # With the width set to zero and the input scrolled to the end of the content, the element's
    # scrollLeft value is the width of the content! Now we add that to the offset.
    inputWidthForNewValue += input.scrollLeft

    # Here we make sure the input doesn't fall off the side of the page. The "-24" is for paddding.
    boardHeader = @$el.find('.js-board-header')[0]
    maxWidth = boardHeader.offsetWidth - 24
    inputWidth = if inputWidthForNewValue < maxWidth then inputWidthForNewValue else maxWidth

    # Now we have an input that's only as wide as the content needs, without running off the page.
    input.style.width = inputWidth + 'px'

    return

  startRenaming: (e) ->
    Util.stop(e)

    return if @isEditingName

    renameButton = @$el.find('.js-rename-board')[0]
    return if !renameButton

    inputWidth = renameButton.offsetWidth

    _.defer =>
      @$('.js-rename-board').addClass('is-editing')
      @$('.js-board-name-input')
        .val(@model.get('name'))
        .css('width', inputWidth)
        .focus()
        .select()

    @isEditingName = true
    track("Board Header", "Open Rename Board From Title")

    return

  stopRenaming: (e) ->
    return if !@isEditingName

    $input = @$('.js-rename-board').removeClass('is-editing')
    if $input.is(":focus") then $input.blur()
    removeAllRanges()

    @isEditingName = false
    @saveBoardName()

    return

  openOrgMenu: (e) ->
    Util.stop(e)

    track("Board Header", "Open Org Menu", $(e.target).closest('.js-open-org-menu').data('boardtype'))

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new BoardHeaderOrgMenuView({ @model, @modelCache })

    return

  renderPermissionLevel: ->
    $perm = @$('#permission-level')
    data =
      permIconClass: BoardDisplayHelpers.getPermLevelIconClassForBoard(@model)
      permText: l(['board perms', @model.getPermLevel(), 'name'])

    $perm.html permsTemplate(data)

    if @isTemplate()
      $perm.attr 'title', BoardDisplayHelpers.getPermLevelAltTextForTemplate(@model)
    else
      $perm.attr 'title', BoardDisplayHelpers.getPermLevelAltTextForBoard(@model)

    canInvite = @model.canInvite(Auth.me())
    @$('.js-manage-board-members').toggle(canInvite)

    @

  postListListRender: ->
    log('render', "rendering inline composer and calculating list layout")
    @renderFilteringStatus()
    @renderInspirationPopover()
    DragSort.refreshListCardSortable()

  renderLists: ->
    @listListView.$el.toggleClass 'js-list-sortable', @model.editable()
    @$('.board-canvas').append @listListView.el
    # Render after adding because postListListRender is dumb and wants the
    # #board element to be in the DOM already
    @listListView.render()
    @listListView.delegateEvents()
    @

  sortCommit: (e, ui) ->
    ui.item.trigger 'movelist', ui

  closeInviteAcceptanceNotification: =>
    @unmountInviteAcceptanceNotification()

  buildInviteAcceptanceNotification: (members) =>
    React.createElement InviteAcceptanceNotification,
      members: members
      onClose: @closeInviteAcceptanceNotification

  # The newly signed up invitees we want to identify here are members who:
  # - were invited by the current user
  # - have completed sign up and joined the board
  # - haven't already notified the current user that they signed up
  getNewlySignedUpInvitees: =>
    myId = Auth.me().id
    lastViewMoment = moment(@model.get('previousDateLastView'))
    membersHash = {}
    @model.memberList.models.forEach (member) =>
      membersHash[member.get('id')] = member

    @model.get('memberships').reduce (newlyInvitedMembers, membership) =>
      member = membersHash[membership.idMember]
      if member &&
         moment(Util.idToDate(member.id)).isAfter(lastViewMoment) &&
         member.get('idMemberReferrer') == myId &&
         member.get('memberType') == 'normal'
        return newlyInvitedMembers.concat(member)
      return newlyInvitedMembers
    , []

  renderPopovers: ->
    # Given that there was a race condition between the Teamless colaboration prompt
    # and the InviteAcceptanceNotification, we needed to control which one to shows first.
    # Now we are showing the InviteAcceptanceNotification first.
    visibleMembers = @model.orderedVisibleMembers()
    newInvitees = @getNewlySignedUpInvitees()
    isInviteDismissed = Auth.me().isDismissed('notify-invite-acceptance')
    canRenderInviteAcceptanceNotification = !isInviteDismissed && newInvitees.length != 0

    # We want to keep track if one of these popovers are currently open or not
    if @isPopoverRendered
      return @

    if canRenderInviteAcceptanceNotification
      # Show InviteAcceptanceNotification if:
      # - there are new invitees
      # - Invite Acceptance hasn't been dismissed
      # - @isPopoverRendered is false
      @renderInviteAcceptanceNotification(newInvitees, _.map visibleMembers, (member) -> member.id)
      newInvitees.forEach((member) ->
        trackUe(
          'board header',
          'sees',
          'new member signed up',
          '',
          '',
          'by invite acceptance notification', {
            referringMember: Auth.me().id,
            newMember: member.id
          }
        )
      )

    else
      # No InviteAcceptanceNotification.
      # Track these users as NOT having seen the invite notification
      newInvitees.forEach((member) ->
        trackUe(
          'board header',
          'doesnt see',
          'new member signed up',
          '',
          '',
          '', {
            referringMember: Auth.me().id,
            newMember: member.id
          }
        )
      )
      # Render the Teamless colaboration prompt if:
      # - there aren't new invitees
      # - if teamless hasn't been dismissed
      # - the invite aceptance notification isn't open
      @renderTeamlessCollaborationPrompt()

    @isPopoverRendered = true

  renderInviteAcceptanceNotification: (newInvitees, visibleMemberIds) =>
    # Find out where the notification should be displayed
    avatarPosition = '#member-count-notifications'
    if newInvitees.length == 1
      if newInvitees[0].id in visibleMemberIds
        possibleAvatarPosition = "#" + newInvitees[0].id + "-avatar"
        newInviteePosition = $(possibleAvatarPosition).offset()?
        # if the new members are not visible then
        # attach the notification to the counter
        if !newInviteePosition
          avatarPosition = possibleAvatarPosition

    # Tear down any existing notifications
    @unmountInviteAcceptanceNotification()

    # Create a new notification
    @inviteAcceptanceNotificationDiv = document.createElement('div')
    @$('#board-header-notification').append(@inviteAcceptanceNotificationDiv)
    @inviteAcceptanceNotificationComponent = ReactDOM.render(
      @buildInviteAcceptanceNotification(newInvitees),
      @inviteAcceptanceNotificationDiv
    )
    avatarObject = $(avatarPosition)
    $(".invite-acceptance-notification").css('left', avatarObject.offset().left - 16)

    @

  unmountInviteAcceptanceNotification: =>
    if @inviteAcceptanceNotificationDiv?
      ReactDOM.unmountComponentAtNode(@inviteAcceptanceNotificationDiv)
      @inviteAcceptanceNotificationDiv = null
      @inviteAcceptanceNotificationComponent = null
    # We want to make sure that we aren't displaying
    # the teamless collaboration popover at the same time
    @isPopoverRendered = false

  renderBoardHeaderFacepile: ->
    $target = @$('.js-fill-facepile')
    visibleMembers = @model.orderedVisibleMembers()
    numMembers = visibleMembers.length
    visibleMembers = visibleMembers.slice(0, MAX_FACEPILE_SIZE)
    overflowMemberCount = numMembers - MAX_FACEPILE_SIZE

    if overflowMemberCount > 0
      @$('.js-fill-board-member-count').text('+' + overflowMemberCount)
    else
      @$('.js-fill-board-member-count').text('')

    subviews = for member in visibleMembers
      @subview(MemberOnBoardView, member, { board: @model })

    if $target.length > 0
      @ensureSubviews(subviews.reverse(), $target)

    @defer =>
      # Disallow adding members to cards from facepile when board is in template mode
      if !@isTemplate()
        DragSort.refreshDraggableSidebarMembers()

      @renderPopovers()

    @

  openAllMembers: (e) ->
    # activated only when there's member overflow from facepile
    Util.stop(e)
    trackUe('board view', 'opens', 'board members breakdown', '', '', 'board-header-button', BoardHeaderAllMembersView)

    newInvitees = @getNewlySignedUpInvitees()

    PopOver.toggle
      elem: @$('.js-open-show-all-board-members')
      view: BoardHeaderAllMembersView
      options: {
        @model,
        @modelCache,
        newInvitees
      }

  openAddMembers: (e) ->
    Util.stop(e)
    if maybeDisplayMemberLimitsError($(e.target), @model)
      return
    trackUe('board view', 'adds', 'board member', '', '', 'board-header-button', BoardMemberAddMultipleView)

    view = new BoardMemberAddMultipleView({ @model, @modelCache })
    view.loadOrgData()

    PopOver.toggle
      elem: $(e.target).closest('.js-open-manage-board-members')
      view: view

    return

  joinBoard: (e) ->
    Util.stop(e)
    if maybeDisplayMemberLimitsError($(e.target), @model, Auth.me())
      return
    @$('.js-join-board').remove()
    @model.joinBoard()
    track("Board Menu", "Join Board via Header")

    return

  changeVis: (e) ->
    Util.stop(e)
    track("Board Header", "Open Change Visibilty via Header")

    PopOver.toggle
      elem: @$('.js-change-vis')
      view: ChangeBoardVisibilityView
      options: { @model, @modelCache, @templateFlagEnabled }

    return

  addBoardToTeam: (e) ->
    Util.stop(e)
    track("Board Header", "Open Add to a Team menu")

    PopOver.toggle
      elem: @$('.js-add-board-to-team')
      view: BoardAddToOrganizationView
      options: { @model, @modelCache }

  openDesc: (e) ->
    Util.stop(e)
    track("Board Header", "Edit Description Button via Header")

    Dialog.show
      view: new BoardDescView({ @model, @modelCache })
      maxWidth: 500

    return

  toggleCalendar: ->
    sendPluginUIEvent(LegacyPowerUps.calendar, {
      action: 'clicked'
      actionSubject: 'button'
      source: 'boardScreen'
      actionSubjectId: 'boardButton'
      objectType: 'powerUp'
      objectId: LegacyPowerUps.calendar
    })
    if @calendarView
      @navigateToBoardEvent()
    else
      @navigateToCalendarEvent()

  navigateToCalendarEvent: ->
    track("Board Header", "Open Calendar View via Header")
    trackUe('board view', 'opens', 'Power-Up', '', '', 'board-button', LegacyPowerUps.calendar)
    @navigateToCalendar()

  navigateToCalendar: ->
    calendarBoardUrl = Controller.getBoardUrl(@model.id, 'calendar')
    Controller.navigate calendarBoardUrl, { trigger: true }

  navigateToBoardEvent: ->
    track("Board Header", "Close Calendar View via Header")
    @navigateToBoard()

  navigateToBoard: ->
    boardUrl = Controller.getBoardUrl(@model.id)
    Controller.navigate boardUrl, { trigger: true }

  isShowingCalendar: -> @calendarView?

  toggleMap: ->
    sendPluginUIEvent(MAP_POWER_UP_ID, {
      action: 'clicked'
      actionSubject: 'button'
      source: 'boardScreen'
      actionSubjectId: 'boardButton'
      objectType: 'powerUp'
      objectId: MAP_POWER_UP_ID
    })
    if @mapView
      if @mapReturnCard
        @closeMap(false)
        Controller.showCardDetail @mapReturnCard
        @mapReturnCard = null
      else
        @navigateToBoardEvent()
    else
      @navigateToMapEvent()

  navigateToMapEvent: ->
    trackUe('board view', 'opens', 'Power-Up', '', '', 'board-button', MAP_POWER_UP_ID)
    trackUe(Noun.BOARD, Verb.OPENS, Noun.BOARD_MAP, '', '', 'by clicking the map button', {
      idBoard: @model.id
    })
    @navigateToMap()

  navigateToMap: (centerTo, returnCard) ->
    @mapCenterTo = centerTo
    @mapReturnCard = returnCard
    mapBoardUrl = Controller.getBoardUrl(@model.id, 'map')
    Controller.navigate mapBoardUrl, { trigger: true }

  toggleButler: (url) ->
    if @butlerView || !url?
      @navigateToBoardEvent()
    else
      @butlerUrl = url
      @navigateToButler(url)

  navigateToButler: ->
    butlerBoardUrl = Controller.getBoardUrl(@model.id, 'butler')
    Controller.navigate(butlerBoardUrl, { trigger: true })

  showMemberProfile: (member) ->
    Controller.saveMemberBoardProfileLocation(member, @model.id)

    Dialog.show
      view: new MemberBoardProfileView({ model: member, board: @model, @modelCache })
      maxWidth: 500
      hide: =>
        Controller.setBoardLocation(@model.id)
    return

  showCalendar: (date) ->
    if !@model.isPowerUpEnabled('calendar') || @isShowingCalendar()
      return

    @$('.calendar-btn').addClass('board-header-btn-enabled')
    @$('#board').addClass('hide')

    boardViewViewLoaders.loadCalendarControllerView()
    .then (CalendarControllerView) =>
      @calendarView = new CalendarControllerView({ @model, @modelCache })
      @$('.board-canvas').append(@calendarView.render(date).el)
      @calendarView.addedToDOM()

  showMap: ->
    if !@model.isMapPowerUpEnabled() || @mapView?
      return

    @$('.js-map-btn').addClass('board-header-btn-enabled')
    @$('#board').addClass('hide')

    boardViewViewLoaders.loadMapView()
    .then (MapView) =>
      @mapView = new MapView({ @model, @modelCache, @mapCenterTo })
      @$('.board-canvas').append(@mapView.render().el)

  showButler: ->
    if @butlerView?
      return
    if !@model.editable()
      @navigateToBoardEvent()
      return
    # this codepath is hit if user goes directly to the /butler route by
    # typing it in the address bar or refreshing while already on it.
    if !@butlerUrl?
      @$('#board').addClass('hide')
      PluginRunner.one
        plugin: BUTLER_POWER_UP_ID
        command: 'show-settings'
        board: @model
      # the Controller no-op's the navigation to the /butler route because
      # we're already on it. But by this time Butler has loaded and provided
      # us its url. So we can finish the job ourselves by calling showButler().
      .then => @showButler()
      return

    @$('#board').addClass('hide')

    boardViewViewLoaders.loadButlerView()
    .then (ButlerView) =>
      @butlerView = new ButlerView({ @butlerUrl })
      @$('.board-canvas').append(@butlerView.render().el)

  closeDetailView: ->
    Dialog.hide(true)
    @closeCalendar(false)
    @closeDirectory(false)
    @closeMap(false)
    @closeButler(false)
    return

  closeCalendar: (navigateToBoard = true) ->
    if @calendarView?
      @calendarView.remove()
      @calendarView = null
      if navigateToBoard
        @navigateToBoard()
      @$('.calendar-btn').removeClass('board-header-btn-enabled')
      @$('#board').removeClass('hide')

      # Hack to resolve a bug where the lists won't have been
      # sized properly if the calendar was visible on initial
      # render (and the board and it's lists were hidden)
      @$('.js-list-name-input').trigger('autosize.resize', false)
    return

  closeMap: (navigateToBoard = true) ->
    if @mapView?
      @mapView.remove()
      @mapView = null
      if navigateToBoard
        @navigateToBoard()
      @$('.js-map-btn').removeClass('board-header-btn-enabled')
      @$('#board').removeClass('hide')
      @$('.js-list-name-input').trigger('autosize.resize', false)
    return

  closeButler: (navigateToBoard = true) ->
    if @butlerView?
      @butlerView.remove()
      @butlerView = null
      if navigateToBoard
        @navigateToBoard()
      @$('#board').removeClass('hide')
      @$('.js-list-name-input').trigger('autosize.resize', false)
    return

  remove: ->
    if @calendarView?
      @calendarView.remove()
    unregisterShortcutHandler(@onShortcut)
    @unmountTeamlessCollaborationPrompt()
    super

  clickCloseDirectory: ->
    if @directoryView
      Analytics.sendUIEvent
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'boardDirectoryCloseButton',
        attributes:
          boardId: @model.id
          organizationId: @model.get('idOrganization')
        source: @directoryView.activeEventSource()

    @toggleDirectory()

  toggleDirectory: ->
    if @directoryView
      if @directoryReturnCard
        @closeDirectory(false)
        Controller.showCardDetail @directoryReturnCard
        @directoryReturnCard = null
      else
        @navigateToBoard()
    else
      @navigateToDirectory()

  navigateToDirectory: (returnCard) ->
    directoryUrl = Controller.getBoardUrl(@model.id, 'power-ups')
    Controller.navigate directoryUrl, { trigger: true }

    @directoryReturnCard = returnCard

    # Close the sidebar menu for window sizes that aren't extra large.
    if !WindowSize.fExtraLarge
      @sidebarView.hideSidebar()

  showDirectory: (section, category, idPlugin, isEnabling) ->
    @$('#board').addClass('hide')

    @directoryView = new DirectoryView({
      @model,
      @modelCache,
      section,
      category,
      idPlugin,
      isEnabling,
      boardView: @
    })
    @$('.board-canvas').append(@directoryView.render().el)

  closeDirectory: (navigateToBoard = true) ->
    if @directoryView?
      @directoryView.remove()
      @directoryView = null
      if navigateToBoard
        @navigateToBoard()
      @$('#board').removeClass('hide')
      @$('.js-list-name-input').trigger('autosize.resize', false)
    return

  openFilter: (e) ->
    Util.stop(e)
    track("Board Header", "Open Filtering via Header")
    @sidebarView.pushView 'filter'
    return

  clearFilters: (e) ->
    Util.stop(e)
    track("Board Header", "Clear Filtering via Header")

    @model.filter.clear()
    return

  openUnsubscribe: (e) ->
    Util.stop(e)

    Confirm.toggle 'unwatch',
      elem: $(e.target).closest('.js-board-header-subscribed')[0]
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        track("Board Header", "Unsubscribe")
        @model.subscribe(false)
    return

  # Because we are using jquery plugins that stop propagation on mousedown events
  # (jquery.dragscrollable and jquery.sortable), we need to handle blurring of inputs
  # and textareas ourselves.
  blurInputsOnBoardClick: (e) ->
    $target = $(e.target)

    # Ignore clicks on inputs and textareas. Note that inputs here can also be submit buttons
    # that are 'programatically' clicked by the DOM upon form submission (on enter keypress)
    clickedInput = $target.is('input') || $target.is('textarea')
    if (clickedInput)
      Util.stopPropagation(e)

    else
      $('input, textarea').blur()

  dblClickAddListMenu: (e) ->
    Util.stop(e)

    if $(e.target).closest('.js-card-templates-button').length > 0
      return

    if  @model.editable()
      if $(e.target).closest('.js-list-content').length == 0
        if !@model.viewState.get('listComposerOpen')
          # They didn't click inside a list
          track("Board View", "Open Add List Menu via Double Click")

          PopOver.show
            clientx: e.clientX
            clienty: e.clientY
            view: new AddListPopoverView
              model: @model
              modelCache: @modelCache
              didAddList: (list) => @scrollToList(list)
      else if (list = @model.viewState.getList())?
        $elClicked = @$(document.elementFromPoint(e.clientX, e.clientY))

        if($elClicked.closest('.list-header-name,.card-composer,.list-card').length == 0)
          $card = @$(document.elementFromPoint(e.clientX, e.clientY - 16)).closest('.list-card')

          track("Board View", "Open Card Composer via Double Click")
          @model.composer.save({
            list: list
            index:
              if $card.length
                # Put the composer one spot after the card above where we double clicked
                Math.max($card.closest('.js-list-cards').find('>.list-card').index($card), 0) + 1
              else
                # Put the composer at the top
                0
            vis: true
          })


    return

  reopen: (e) ->
    Util.stop(e)
    org = @model.getOrganization()
    @model.getNewBillableGuests().then ({ newBillableGuests, availableLicenseCount }) =>
      if newBillableGuests.length > 0
        PopOver.show
          elem: @$('.js-reopen')
          view: new ReopenBoardPopoverView {
            board: @model
            org
            newBillableGuests
            availableLicenseCount
          }
      else
        @model.reopen()

  delete: (e) ->
    Util.stop(e)

    Confirm.toggle 'delete board',
      elem: e.target
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.startDelete()
        .then =>
          track("Board", "Delete", "Via Closed Board")
        .done()

  updateControllerTitle: ->
    Controller.title(@model.get('name'))

  copyBoard: (e) ->
    Util.stop(e)
    PopOver.toggle
      elem: @$(e.target).closest('.js-copy-board')
      view: new CopyBoardView({ @model, @modelCache })

  # Returns the idList/index to move a card to.  It prefers to move the card
  # above the card that is 'active', and will fall back to inserting the card
  # at the bottom of idListDefault if no card is active
  _insertCardPosition: (idListDefault) ->
    activeCard = @model.viewState.getCard()
    if activeCard?
      idList: activeCard.get('idList')
      index: activeCard.getIndexInList()
    else
      idList: idListDefault
      index: @model.listList.get(idListDefault).cardList.length

  moveCardRequested: (listView, { shortLink, idList }) ->
    { idList, index } = @_insertCardPosition(idList)
    idCard = IdCache.getId('Card', shortLink) ? shortLink

    Card.load(idCard, Payloads.cardMinimal, @modelCache)
    .then (card) =>
      list = @model.listList.get(idList)
      if card.get('idList') == idList || canAddCard({ destinationList: list })
        card.moveToList(list, index)
    .done()

  copyCardRequested: (listView, { shortLink, idList }) ->
    { idList, index } = @_insertCardPosition(idList)
    idCard = IdCache.getId('Card', shortLink) ? shortLink

    Card.load(idCard, Payloads.cardMinimal, @modelCache)
    .then (card) =>
      list = @model.listList.get(idList)

      options = {
        hasChecklists: card.checklistList.length > 0,
        hasAttachments: card.attachmentList.length > 0,
        destinationBoard: @model,
        destinationList: list
      }
      if canAddCard(options)
        card.copyTo
          idList: idList
          pos: @model.listList.get(idList).calcPos(index, card)
    .done()

  showCleanUp: (e) ->
    Util.stop(e)

    track("Board Header", "Show Clean-Up")

    view = new BoardCleanUpView({ @model, @modelCache })
    Dialog.show
      view: view
      maxWidth: 800
      hide: ->
        view.abort()

    return

  renderInviteeOrientation: ->
    @$('.board-canvas').append('<div class="invitee-orientation-mount-point"></div>')

    inviteeOrientationView = @subview InviteeOrientationView, @model,
      modelCache: @modelCache

    @ensureSubview(inviteeOrientationView, @$('.invitee-orientation-mount-point'))

  renderBoardHeaderMap: ->
    if @model.isMapPowerUpEnabled()
      GoogleMapsApi.load()
        .then =>
          @$('.js-map-btn').removeClass('hide')
    else
      @$('.js-map-btn').addClass('hide')
    @

  onTeamCreatedFromCollaborationPrompt: (orgName) =>
    Controller.organizationBoardsView(orgName, { shouldShowTeamfulCollaborationPrompt: true })
      .then(=> @unmountTeamlessCollaborationPrompt())

  unmountTeamlessCollaborationPrompt: =>
    if @teamlessCollaborationPromptDiv?
      ReactDOM.unmountComponentAtNode(@teamlessCollaborationPromptDiv)

    # We want to make sure that we aren't displaying
    # the invite acceptance popover at the same time
    @isPopoverRendered = false

  renderTeamlessCollaborationPrompt: =>
    if !@teamlessCollaborationPromptDiv?
      targetDiv = $("#teamless-collaboration-prompt-target")[0]

      if targetDiv?
        @teamlessCollaborationPromptDiv = targetDiv
      else
        $('#surface').append("<div id='teamless-collaboration-prompt-target'></div>")
        @teamlessCollaborationPromptDiv = $("#teamless-collaboration-prompt-target")[0]

      @teamlessCollaborationPromptComponent = React.createElement(
        TeamlessCollaborationPrompt,
        {
          boardId: @model.id,
          onClose: @unmountTeamlessCollaborationPrompt,
          onTeamCreated: @onTeamCreatedFromCollaborationPrompt,
          target: => @$('.js-board-header-btn-org-wrapper')[0]
        }
      )

    if !featureFlagClient.get('bizteam.teamless_collaboration_prompt', false) || \
     Auth.me().isDismissed("TeamlessCollaborationPrompt-#{@model.id}")
      return

    renderComponent(
      @teamlessCollaborationPromptComponent,
      @teamlessCollaborationPromptDiv
    )
